import { MachineGuards } from 'common/bento/types/MachineConfig';

import { OptionValue } from '../libs/capitalDepositEUBankAccountSchema';
import { Model } from './model';

export enum Guard {
  HasUserAnsweredNo = 'hasUserAnsweredNo',
}

const guards: MachineGuards<Model, Guard> = {
  hasUserAnsweredNo: (context, event) => {
    if (event.type !== 'SUBMIT') {
      throw new Error(`hasUserAnsweredNo called on event ${event.type}`);
    }

    return event.values.hasEuropeanBankAccount === OptionValue.NO;
  },
};

export default guards;
